module.exports = __webpack_public_path__ + "static/space-shuttle-0b27bebb1461fa86495e38f6f94c7096.png";